import { Col, Flex, Spacer, View } from '@amzn/stencil-react-components/layout';
import { H4, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SUPPORT_SIM_LINK } from '../../constants/urlConstants';
import BorderedView from './BorderedView';
import { IconExclamationTriangle } from '../../mocks/stencilV4IconMocks';

const ErrorComponent = () => {
  return (
    <Flex
      flexDirection="row"
      gridGap="S400"
      alignItems="stretch"
      justifyContent="stretch"
      flex={1}
      height="100%"
    >
      <Col
        flex={1}
        alignItems="center"
        justifyContent="center"
        gridGap="S100"
        backgroundColor={'whiteBg'}
      >
        <BorderedView
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <View display="flex" justifyContent="center" alignItems="center">
            <IconExclamationTriangle />
            <Spacer width={10} />
            <H4>
              <FormattedMessage id="app.errorComponent.header" />
            </H4>
          </View>
          <Text>
            <FormattedMessage id="app.errorComponent.ticket" />{' '}
            <a href={SUPPORT_SIM_LINK}>
              <FormattedMessage id="app.noAccessComponent.supportLink" />
            </a>
          </Text>
        </BorderedView>
      </Col>
    </Flex>
  );
};

export default ErrorComponent;
